<template>
    <div v-loading="isLoadingSetting || isLoadingContractors">
        <!-- Add New Location Button -->
        <el-row>
            <el-col :span="24">
                <!-- Button: open the Contractor modal -->
                <el-button
                        type="primary"
                        icon="el-icon-plus"
                        @click="handleOpenContractorModal(null)"
                        v-if="settingHasAccess"
                >
                    Add
                </el-button>
                <!-- Contractor Modal -->
                <el-dialog
                    :title="contractorModalTitle"
                    :visible.sync="showContractorModal"
                    top="10vh"
                    @closed="handleClosedContractorModal"
                >
                    <el-form
                            v-if="showContractorForm"
                            ref="form"
                            :model="form"
                            label-width="120px"
                            :rules="rules"
                    >
                        <el-form-item label="Name" prop="name">
                            <el-input
                                    v-model="form.name"
                                    placeholder="Please enter the name"
                            ></el-input>
                        </el-form-item>
                        <!--Footer Buttons-->
                        <el-form-item>
                            <el-button v-if="this.form.id !== ''" type="primary" @click="handleSubmit('form')" :loading="usUpdateContractor" :disabled="isLoadingNzPostObj">Save</el-button>
                            <el-button v-else type="primary" @click="handleSubmit('form')" :loading="isAddingContractor" :disabled="isLoadingNzPostObj">Create</el-button>
                            <el-button @click="handleRest('form')">Reset</el-button>
                        </el-form-item>
                    </el-form>
                </el-dialog>
            </el-col>
        </el-row>
        <br/>
        <!-- Contractors Table -->
        <el-row>
            <el-col :span="24">
                <el-table
                        v-if="! isLoadingSetting"
                        style="width: 100%"
                        :data="carrierContractors"
                        border
                        :default-sort = "{prop: 'name', order: 'ascending'}"
                >
                    <el-table-column
                            prop="name"
                            label="Name"
                            min-width="25%"
                            sortable
                    ></el-table-column>
                    <el-table-column
                            label="Action"
                            align="center"
                            min-width="25%"
                            v-if="settingHasAccess"
                    >
                        <template slot-scope="scope">
                            <el-button size="mini" type="text" @click="handleOpenContractorModal(scope.row)">Edit</el-button>
                            <el-button size="mini" type="text" @click="handleDeleteContractor(scope.row)">Delete</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <br/>
                <el-alert
                        v-if="! settingHasAccess"
                        :title="`Found something wrong? Please contact ${businessOwner} to update the information.`"
                        type="info"
                        show-icon>
                </el-alert>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        components: {
        },
        data () {
            const emptyForm = {
                id: '',
                name: '',
            };
            return {
                isLoadingNzPostObj: false,
                showContractorModal: false,
                showContractorForm: false,
                emptyForm,
                form: emptyForm,
                rules: {
                    name: [
                        { required: true, message: 'Please enter a name', trigger: 'blur' }
                    ],
                }
            }
        },
        methods: {
            handleOpenContractorModal(contractor = null) {
                if (contractor) {
                    this.form = {...contractor};
                } else {
                    this.form = {...this.emptyForm};
                }
                this.openContractorModal();
            },
            handleClosedContractorModal() {
               this.showContractorForm = false;
            },
            openContractorModal() {
                this.showContractorModal = true;
                this.showContractorForm = true;
            },
            closeContractorModal() {
                this.showContractorModal = false;
            },
            handleDeleteContractor(contractor) {
                this.$confirm(`Sure to delete ${contractor.name}?`, 'Confirm', {
                    type: 'warning',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = 'Deleting...';
                            this.deleteContractor(contractor)
                                .catch(e => {
                                    console.log(e);
                                    this.$message.error('Failed to delete the contractor.');
                                }).then(() => {
                                    instance.confirmButtonLoading = false;
                                    done();
                            })
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    this.$message.success('Deleted the contractor successfully.')
                }).catch(() => {
                    //click cancel
                });
            },
            handleSubmit (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        const data = {
                            id: this.form.id,
                            name: this.form.name,
                        };
                        if (data.id) {
                            //update Contractor
                            this.$store.dispatch('updateContractor', data)
                                .then(() => {
                                    this.closeContractorModal();
                                    this.$message.success('Updated this contractor successfully.');
                                }).catch(e => {
                                    console.log(e);
                                    this.$message.error('Sorry, failed to update this contractor.');
                                });
                        } else {
                            //create Contractor
                            this.$store.dispatch('addContractor', data)
                                .then(() => {
                                    this.closeContractorModal();
                                    this.$message.success('Added this contractor successfully.');
                                }).catch(e => {
                                    console.log(e);
                                    this.$message.error('Sorry, failed to add this contractor.');
                                });
                        }
                    } else {
                        return false;
                    }
                });
            },
            handleRest(formName) {
                this.$refs[formName].resetFields();
            },
            loadContractors () {
                this.$store.dispatch('loadContractors')
                    .catch(() => {
                        this.$message.error('Sorry, failed to load your contractors');
                    });
            },
            deleteContractor (contractor) {
                return this.$store.dispatch('deleteContractor', contractor.id);
            },
            mapForm (form) {
                return {
                    id: form.id,
                    name: form.name,
                }
            },
        },
        mounted() {
            this.loadContractors();
        },
        computed: {
            businessOwner() {
                return typeof window.Freighthub.business !== 'undefined' ? window.Freighthub.business.ownerName : 'Business Owner';
            },
            settingHasAccess () {
                return this.$store.getters.getIfSettingHasAccess;
            },
            isLoadingSetting () {
                return this.$store.getters.getTruckRunningSettingLoadStatus === 1;
            },
            isLoadingContractors: function () {
                return this.$store.getters.getContractorsLoadStatus === 1;
            },
            carrierContractors: function () {
                return this.$store.getters.getContractors;
            },
            isAddingContractor: function () {
                return this.$store.getters.getContractorAddStatus === 1;
            },
            usUpdateContractor: function () {
                return this.$store.getters.getContractorUpdateStatus === 1;
            },
            contractorModalTitle: function () {
                if (this.form.id !== '') {
                    return `Edit Contractor ${this.form.name}`;
                } else {
                    return 'New Contractor';
                }
            }
        }
    }
</script>

<style scoped>
    >>> svg {
        vertical-align: unset;
    }
</style>